/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  SaveAgentDraftBody
} from './model/saveAgentDraftBody.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List the caller's launch drafts in the active organization.
 */
export const listAgentDrafts = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/agent-drafts`, method: 'GET', signal
    },
      options);
    }




export const getListAgentDraftsQueryKey = () => {
    return [
    `/agent-drafts`
    ] as const;
    }


export const getListAgentDraftsQueryOptions = <TData = Awaited<ReturnType<typeof listAgentDrafts>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgentDrafts>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentDraftsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentDrafts>>> = ({ signal }) => listAgentDrafts(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgentDrafts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAgentDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentDrafts>>>
export type ListAgentDraftsQueryError = unknown


/**
 * @summary List the caller's launch drafts in the active organization.
 */

export function useListAgentDrafts<TData = Awaited<ReturnType<typeof listAgentDrafts>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgentDrafts>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAgentDraftsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create or update a launch draft.
 */
export const saveAgentDraft = (
    saveAgentDraftBody: SaveAgentDraftBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/agent-drafts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveAgentDraftBody, signal
    },
      options);
    }




export const getSaveAgentDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAgentDraft>>, TError,{data: SaveAgentDraftBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAgentDraft>>, TError,{data: SaveAgentDraftBody}, TContext> => {

const mutationKey = ['saveAgentDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAgentDraft>>, {data: SaveAgentDraftBody}> = (props) => {
          const {data} = props ?? {};

          return  saveAgentDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveAgentDraftMutationResult = NonNullable<Awaited<ReturnType<typeof saveAgentDraft>>>
    export type SaveAgentDraftMutationBody = SaveAgentDraftBody
    export type SaveAgentDraftMutationError = unknown

    /**
 * @summary Create or update a launch draft.
 */
export const useSaveAgentDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAgentDraft>>, TError,{data: SaveAgentDraftBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveAgentDraft>>,
        TError,
        {data: SaveAgentDraftBody},
        TContext
      > => {
      return useMutation(getSaveAgentDraftMutationOptions(options));
    }
    /**
 * @summary Delete a launch draft.
 */
export const deleteAgentDraft = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/agent-drafts/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAgentDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgentDraft>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAgentDraft>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAgentDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAgentDraft>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAgentDraft(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAgentDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAgentDraft>>>

    export type DeleteAgentDraftMutationError = unknown

    /**
 * @summary Delete a launch draft.
 */
export const useDeleteAgentDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgentDraft>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAgentDraft>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteAgentDraftMutationOptions(options));
    }
